<template>

  <div class="components-container">
    <KioskCarousel id="carousel" :slides="slides" :theme="carouselTheme"/>
    <EventsCalendar id="calendar" :events="events" :theme="calendarTheme"/>
  </div>

  <div id="overlay-container" class="components-container">

    <div id="left-container">
      <div id="logo-space">
        <div class="logo-container">
          <img src="./assets/logo_itts.svg" alt="logo ITIS">
        </div>
      </div>
      <div id="clock-container" v-show="showCurrentTime">
        <p>{{currentTime}}</p>
      </div>
    </div>

    <div id="right-container" class="logo-container">
      <img src="./assets/logo_kiosk.svg" alt="logo Kiosk" id="logo_kiosk">
    </div>

    <div class="alerts-container">
      <div id="alert-error" class="alert alert-danger m-2 w-100" v-show="errorAlertMessage">
        <p class="h2">Errore</p>
        <p>{{ errorAlertMessage }}</p>
      </div>
    </div>

  </div>

</template>

<script>
import KioskCarousel from './components/KioskCarousel.vue'
import EventsCalendar from './components/EventsCalendar.vue'
import CONSTANTS from './constants.json'

export default {
  data(){
    return{
      currentTime: '00:00',
      showCurrentTime: false,
      errorAlertMessage: false,
      API_URL : CONSTANTS.API_URL, //api: http://kiosk.divini.cloud/api/v2/kioskAPI.php, json http://localhost:3000/data
      slides: [{id: 0, body: "", title: ""}],
      events: [
        {
          date: "2022/01/03",
          day: 3,
          weekday: 1,
          events: []
        },
        {
          date: "2022/01/04",
          day: 4,
          weekday: 2,
          events: []
        },
        {
          date: "2022/01/05",
          day: 5,
          weekday: 3,
          events: []
        },
        {
          date: "2022/01/06",
          day: 6,
          weekday: 4,
          events: []
        },
        {
          date: "2022/01/07",
          day: 7,
          weekday: 5,
          events: []
        },
        {
          date: "2022/01/08",
          day: 8,
          weekday: 6,
          events: []
        },
        {
          date: "2022/01/09",
          day: 9,
          weekday: 7,
          events: []
        }
      ],
      calendarTheme: {
        0: ['#ff8B46', '#eb5307', '#db5709', '#eee'],
        1: ['#3566db', '#0d40b8', '#00298c', '#eee'],
        2: ['#bdbdbd', '#949494', '#666666', '#222'],
        header: '#fff',
        grid: '#fff',
      },
      carouselTheme: {
        background: 'lightcyan',
        dotspace: 'lightblue',
        dots: 'blue',
        text: 'black'
      }
    }
  },
  methods:{
    setCurrentTime(){
      let current = new Date()
      this.currentTime = `${String(current.getHours()).padStart(2, '0')}:${String(current.getMinutes()).padStart(2, '0')}`
    },
    updateData(){
      //fetch data
      fetch(this.API_URL)
          .then(res => {
            if (res.ok) return res.json()
            else {
              console.log(`attempt to fetch at ${this.API_URL} has failed`)
              console.log(`response: ${res}`)
              this.errorAlertMessage = 'si è verificato un errore. status code: ' + res.status
            }
          })
          .then(data => {

            for(let day of data.events){
              day.day = parseInt(day.date.slice(-2))
            }

            if (data.slides.length) this.slides = data.slides;
            if (data.events.length > 2) this.events = data.events;

            if (typeof(data.carouselTheme)==='object')
              this.carouselTheme = {...this.carouselTheme, ...data.carouselTheme};

            if (typeof(data.calendarTheme)==='object')
              this.calendarTheme = {...this.calendarTheme, ...data.calendarTheme};

            this.errorAlertMessage = false
          })
          .catch(error => {
            console.log(`attempt to fetch at ${this.API_URL} has failed`)
            console.log(`errore: ${error}`)
            this.errorAlertMessage = 'impossibile raggiungere il server, assicurati di essere connesso a internet'
          })
    },
  },
  beforeMount() {
    const DEFAULT_SLIDE = CONSTANTS.DEFAULT_SLIDE
    this.slides = [DEFAULT_SLIDE]
  },
  mounted() {
    //first calls
    this.updateData()
    this.setCurrentTime()

    //update data (caruosel and events)
    setInterval(this.updateData, 30000) /*30 seconds*/
    //update time
    setInterval(this.setCurrentTime, 1000); /*1 second*/
  },
  name: 'App',
  components: {
    KioskCarousel, EventsCalendar
  }
}
</script>

<style>
html{
  overflow: hidden; /*some elements are bigger than they should (that's an issue) and generate overflow*/
}
html, body, #app, .components-container{
  margin: 0;
  height: 100%;
  width: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#logo-space{
  height: calc(100% - 30px);
}
.logo-container{
  --logo-padding-top: 8px;
  --logo-padding-right: 20px;
  --logo-padding-bottom: 15px;
  --logo-padding-left: 20px;
  height: calc(100% - var(--logo-padding-top) + var(--logo-padding-bottom));
  padding: var(--logo-padding-top) var(--logo-padding-right) var(--logo-padding-bottom) var(--logo-padding-left);
}
.logo-container>img{
  width: 100%;
  object-fit: contain;
}
#clock-container{
  vertical-align: center;
  height: 30px;
}
#clock-container>p{
  text-align: center;
  margin: 0;
  font-size: 30px;
}
.components-container{
  display: grid;
  grid-template-columns: 14vw 1fr 14vw;
  grid-template-rows: minmax(0, 1fr) minmax(0, 2fr);
}
#overlay-container{
  position: fixed;
  top: 0;
  right: 0;
}
#carousel{
  grid-column-start: 1;
  grid-column-end: 4;
}
#calendar{
  grid-column-start: 1;
  grid-column-end: 4;
}
#left-container{
  grid-column: 1 / 2;
}
.alerts-container{
  grid-column: 2 / 3;
  grid-row: 1 / 3;
}
#alert-error{
  display: inline-block;
}
#right-container{
  grid-column: 3 / 4;
}
</style>
